import React from 'react';
import HubTabs from '../../components/syndication/HubTabs';
import SyndicationDisbursements from './SyndicationDisbursements';
import WithdrawalRequestsAdmin from '../WithdrawalRequestsAdmin';
import SyndicationWithdrawals from '../SyndicationWithdrawals';

// Withdrawals + Withdrawal Requests + Disbursements → one page. Old URLs redirect here with ?tab=.
export default function DisbursementsHub() {
  return (
    <HubTabs title="Disbursements" subtitle="Investor requests, the payout cart, and every withdrawal on record." testId="disbursements-hub"
             fallback="payout"
             tabs={[
               { key: 'payout', label: 'Pay out', render: () => <SyndicationDisbursements embedded /> },
               { key: 'requests', label: 'Requests', render: () => <WithdrawalRequestsAdmin embedded /> },
               { key: 'history', label: 'All withdrawals', render: () => <SyndicationWithdrawals embedded /> },
             ]} />
  );
}
